<template>
    <modal
        v-if="show"
        :form="form"
        type="is-primary"
        size="is-small"
        :title="textTitleModal"
        :submit-text="textSubmitModal"
        :success-text="textSuccessModal"
        :submit-disabled="submitDisabled"
        class="has-selectize"
        @submit="save"
        @closed="closed"
    >
        <add-payment-methods ref="paymentMethods" :form="form" :backup="backup" @closed="closed" />
    </modal>
</template>

<script>
import Form from 'core/Form';
import AddPaymentMethods from 'components/PaymentMethods/AddPaymentMethods';
import validator from 'utils/validator';
import { mapState } from 'pinia';
import stores from 'store/modules';

export default {
    components: {
        AddPaymentMethods,
    },

    props: {
        show: { type: Boolean, default: false },
        backup: { type: Boolean, default: false },
    },

    emits: ['closed'],

    data: () => ({
        form: new Form(
            {
                name: '',
                email: '',
                card_token: '',
                primary: false,
                backup: false,
                type: 'default',
                confirm: false,
            },
            false
        ),
        paymentMethods: null,
    }),

    computed: {
        submitDisabled() {
            if (this.form.type === 'default') return false;

            return Boolean(!this.form.name || !validator.isEmail(this.form.email));
        },

        textTitleModal() {
            if (this.backup) {
                return 'Add Backup Payment Method';
            }

            return 'Add Payment Method';
        },

        textSubmitModal() {
            if (this.form.type === 'default') {
                return 'Add Payment Method';
            }

            if (this.form.confirm) {
                return 'Confirm';
            }

            return 'Send';
        },

        textSuccessModal() {
            if (this.form.type === 'default') {
                return 'Payment Method Added';
            }

            return '';
        },

        ...mapState(stores.EarlyUpgrade, [
            'paymentMethodsFromInbox',
            'paymentMethodsFromBroadcast',
        ]),
    },

    watch: {
        show(status) {
            if (status) {
                this.$nextTick(() => {
                    this.paymentMethods = this.$refs.paymentMethods;
                });
            }
        },
    },

    methods: {
        closed() {
            this.form.reset();
            this.$emit('closed');
        },

        async save() {
            const data = await this.paymentMethods.save();

            if (data.stripeError || data.formErrors) return;

            await this.closed();

            if (this.paymentMethodsFromInbox) {
                this.$router.push({
                    path: '/settings/billing/auto-recharge',
                    query: {
                        redirect: `/settings/organization/inboxes/all-inboxes/${this.paymentMethodsFromInbox}/numbers`,
                    },
                });
            }

            if (this.paymentMethodsFromBroadcast) {
                this.$router.push({
                    path: '/settings/billing/auto-recharge',
                    query: { redirect: '/broadcasts/create' },
                });
            }
        },
    },
};
</script>
